import React from "react";
import { CustomList } from "components/index";
import { formatHoursToTime } from "components/timesheet/utils";
import DepartmentEmployeesFilters from "../components/filters";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";
import { CURRENT_MONTH_END_DATE, CURRENT_MONTH_START_DATE } from "@/lib/utils";
import { TotalHoursCell } from "@/components/hours/cell";
import { TotalNumberCell } from "@/components/number/cell";

export default function TimesheetDepartmentEmployees() {
  function roundToOneDecimal(num) {
    return Math.round(num);
  }

  const user = useSelector(selectUser);

  const columns = [
    {
      accessorKey: "employee",
      header: "Name",
      cell: ({ row }) =>
        `${row.original.employee.first_name} ${row.original.employee.last_name}`,
      footer: "Total",
    },
    {
      accessorKey: "total_projects",
      header: "Total Projects",
      footer: TotalNumberCell("projects"),
    },
    {
      accessorKey: "total",
      header: "Logged",
      cell: ({ row }) => formatHoursToTime(row.original.total),
      footer: TotalHoursCell("total"),
    },
    {
      accessorKey: "draft_hours",
      header: "Draft",
      cell: ({ row }) => formatHoursToTime(row.original.draft_hours),
      footer: TotalHoursCell("draft_hours"),
    },
    {
      accessorKey: "internal_project_hours",
      header: "Internal",
      cell: ({ row }) => formatHoursToTime(row.original.internal_project_hours),
      footer: TotalHoursCell("internal_project_hours"),
    },
    {
      accessorKey: "client_project_hours",
      header: "Client",
      cell: ({ row }) => formatHoursToTime(row.original.client_project_hours),
      footer: TotalHoursCell("client_project_hours"),
    },
    {
      accessorKey: "presales_project_hours",
      header: "Pre Sales",
      cell: ({ row }) => formatHoursToTime(row.original.presales_project_hours),
      footer: TotalHoursCell("presales_project_hours"),
    },
    {
      accessorKey: "utilization_percentage",
      header: "Utilization",
      cell: ({ row }) =>
        `${roundToOneDecimal(row.original.utilization_percentage)}%`,
    },
  ];

  const defaultFilters = {
    departmentId: user.department?.id,
    startDate: CURRENT_MONTH_START_DATE,
    endDate: CURRENT_MONTH_END_DATE,
  };

  const exportFields = [
    "employee.employee_id",
    "employee.first_name",
    "employee.last_name",
    "total",
    "internal_project_hours",
    "client_project_hours",
    "presales_project_hours",
    "total_projects",
    "utilization_percentage",
  ];

  return (
    <div>
      <CustomList
        endPoint="custom-ui/get-department-employee-utilization-summary"
        columns={columns}
        perPage={200}
        renderFilters={DepartmentEmployeesFilters}
        teleportFilters={true}
        export={true}
        fields={exportFields}
        filters={defaultFilters}
        href={(item) =>
          `/reports/timesheet/employees/${item.employee.id}`
        }
        linkProps={{ target: "_blank" }}
        hidePagination={true}
      />
    </div>
  );
}
